import { cn } from "@fronterahealth/frontera-ui-components/lib/utils";
import { RevealOnFieldHover as BaseRevealOnFieldHover } from "@fronterahealth/frontera-ui-components/ui/reveal-on-field-hover";

// Touch screens have no hover, so the revealed controls would never show.
const SHOWN = "grid-cols-[1fr] [&>div]:translate-x-0 [&>div]:opacity-100";
const SHOWN_WITHOUT_HOVER = `[@media(hover:none)]:grid-cols-[1fr] [@media(hover:none)]:[&>div]:translate-x-0 [@media(hover:none)]:[&>div]:opacity-100`;

interface RevealOnFieldHoverProps extends React.ComponentProps<typeof BaseRevealOnFieldHover> {
  /** Show the controls at rest on every device, not only on touch screens. */
  alwaysVisible?: boolean;
}

/** Mosaic's RevealOnFieldHover, always shown on touch screens. */
export const RevealOnFieldHover: React.FC<RevealOnFieldHoverProps> = ({
  alwaysVisible = false,
  className,
  ...props
}) => (
  <BaseRevealOnFieldHover
    data-always-visible={alwaysVisible}
    className={cn(alwaysVisible ? SHOWN : SHOWN_WITHOUT_HOVER, className)}
    {...props}
  />
);
